export default __webpack_public_path__ + "Src/Client/Tiles/LoginTile/loginTile.html";